import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { AbstractMainAuthorForm } from 'src/app/models/Iabstracttableitem';
import { MergeForm, MergeResource } from 'src/app/models/imerge.interface';
import { IPerson } from 'src/app/models/iperson.interface';
import { environment } from 'src/environments/environment';
import { MessageToastService } from '../common/message-toast.service';

@Injectable({
  providedIn: 'root'
})
export class MergeService {

  private url = 'merge';
  private api = environment.apiUrl;

  constructor(private http: HttpClient, private msg: MessageToastService) { }

  getMatches(id: string) : Observable<MergeResource> {
    return this.http.get<MergeResource>(`${this.api}${this.url}/${id}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  getMatchesAbstract(id: string) : Observable<MergeResource> {
    return this.http.get<MergeResource>(`${this.api}${this.url}/abstracts/${id}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  mergeConference(id: number) : Observable<IPerson[]> {
    return this.http.get<IPerson[]>(`${this.api}${this.url}/conf/${id}`).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }

  mergePerson(form: MergeForm) : Observable<IPerson> {
    return this.http.post<IPerson>(`${this.api}${this.url}`, form).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }
  mergeAbstract(form: MergeForm) : Observable<IPerson> {
    return this.http.post<IPerson>(`${this.api}${this.url}/abstract`, form).pipe(
      catchError(err => {
        this.msg.errorEx(err);
        return EMPTY;
      }),
      shareReplay()
    );
  }


}
